import { jwtDecode } from "jwt-decode";

export interface TokenClaims {
  roles?: string[];
  permissions?: string[];
  exp?: number;
}

export const checkUserAuthorization = (
  token: string,
  requiredRole: string
): boolean => {
  try {
    const decoded: TokenClaims = jwtDecode(token);
    if (!decoded.exp || Date.now() >= decoded.exp * 1000) {
      throw new Error("Token has expired");
    }
    return decoded.roles?.includes(requiredRole) || false;
  } catch (error) {
    console.error("Error decoding token: ", error);
    return false;
  }
};
